import React from 'react';
const SVG = ({
    style = {},
    fill = '#999',
    viewBox = '0 0 67.575 14',
    width = '67.575',
    className = '',
    height = '14',
    ...rest
  }) => (
    <svg 
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        style={style}
        height={height}
        viewBox={viewBox}
        fill={fill}>
            <path d="M25.392 17.754l-5.149 2.816 5.149 2.922 5.18-2.922z"  transform="translate(-20.243 -17.754)"/>
            <path d="M29.721 32.312l-4.328 2.453-4.333-2.453-.817.453v4.143l5.149 2.917 5.18-2.917v-4.143z"  transform="translate(-20.243 -25.825)"/>
            <path d="M29.737 27.666l-4.345 2.458-4.331-2.458-.819.453 5.149 2.922 5.18-2.922z"  transform="translate(-20.243 -23.249)"/>
    </svg>
);
export default SVG;